import React from 'react';
import { StepProps } from '../MultiStepModal';

export default function CertificateTemplateMetaStep({ data, onDataChange }: StepProps) {
  const setField = (key: string, value: any) => onDataChange({ [key]: value });

  return (
    <div className="step-form">
      <div className="step-header">
        <h3 className="step-form-title">Template details</h3>
        <p className="step-form-subtitle">Give this template a prefix, type name, and label.</p>
      </div>

      <div className="step-form-content">
        <div className="form-group">
          <label className="form-label">Certificate prefix *</label>
          <input
            className="form-input"
            placeholder="CP12"
            value={data.certificatePrefix || ''}
            onChange={(e) => setField('certificatePrefix', e.target.value)}
          />
          <div className="text-xs text-[#686E6C] mt-1">
            This is the official identifier (e.g. CP12, CP17).
          </div>
        </div>

        <div className="form-group">
          <label className="form-label">Certificate type name *</label>
          <input
            className="form-input"
            placeholder="Landlord Gas Safety Record"
            value={data.certificateTypeName || ''}
            onChange={(e) => setField('certificateTypeName', e.target.value)}
          />
        </div>

        <div className="form-group">
          <label className="form-label">Template label *</label>
          <input
            className="form-input"
            placeholder="Standard CP12"
            value={data.templateLabel || ''}
            onChange={(e) => setField('templateLabel', e.target.value)}
          />
        </div>
      </div>
    </div>
  );
}
